export default {
    /**
     * Sets user data
     *
     * @param    {object}   state   Vuex state.
     * @param   {object}  userData   User data.
     *
     */
    setUser(state, userData) {
        if (userData.meta_data) {
            if (Array.isArray(userData.meta_data)) {
                userData.meta_data = {};
            }
        }

        if (! userData?.meta_data?.avatar) {
            userData.meta_data.avatar = '';
        }

        state.user = { ...state.user, ...userData };
    },

    /**
     * Sets register flag
     *
     * @param   {object}  state  Vuex state.
     * @param   {string}  payload  New Avatar url.
     */
    newAvatar(state, payload) {
        state.user.meta_data.avatar = payload;
    },

    /**
     * Sets user meta
     *
     * @param   {object}   state Vuex state.
     * @param   {object}   meta  User meta.
     *
     */
    replaceUserMeta(state, meta) {
        state.user = {
            ...state.user,
            meta_data: {
                ...meta,
            },
        };
    },

    /**
     * Set login redirect url.
     *
     * @param {object} state  Vuex state.
     * @param {string} url    Redirect URL.
     */
    setLoginRedirectUrl(state, url) {
        state.loginRedirectUrl = url;
    },

    /**
     * Set profile controls
     *
     * @param {object} state    Vuex state.
     * @param {*}      controls Profile controls array or false on error.
     */
    setProfileControls(state, controls) {
        state.profileControls = controls;
    },
};
